


























































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import { BUTTON } from '@/constants/label';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import { Color, OutStatus, JuchuStatus, TorikeshiFlg } from '@/constants/constants';
import { dateStrToNum } from '@/utils/utils';
import CtrlMessageDialog from '../common/control/CtrlMessageDialog.vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_040_HatchuConfirm_Rireki_Table',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    Color,
    JuchuStatus,
    TorikeshiFlg,
    items: [],
    headers: [
      {
        text: '履歴№',
        value: 'rirekiNo',
        sortable: false,
        width: 70,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '受注日',
        value: 'juchuYmd',
        sortable: false,
        width: 100,
        class: 'text-center',
        cellClass: 'text-center',
      },
      {
        text: '工場状態',
        value: 'kojoJotaiKbMei',
        sortable: false,
        width: 130,
        class: 'text-center',
        cellClass: 'text-center',
      },
      {
        text: '発注連絡事項',
        value: 'hatchuRenrakuJiko',
        class: 'text-start',
        cellClass: 'text-start',
        sortable: false,
        width: 600,
      },
      { text: '', value: 'action', sortable: false, width: 50 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    messageShow: false,
    messageId: '',
    messageTextParam: [],
  }),
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 400;
    },
  },
  methods: {
    callParentInfo(item: any) {
      this.childItem.hatchuShuseiCount = item.hatchuShuseiCount;
      this.$emit('info', this.childItem);
    },
    hide() {
      this.$emit('hide');
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      this.hide();
    },
    async getRireki() {
      this.$store.dispatch('common/setIsLoading', true);

      const params = {
        hatchuJigyoshoCd: this.childItem.hatchuJigyoshoCd,
        hatchuEntryYmd: dateStrToNum(this.childItem.hatchuEntryYmd),
        hatchuNo: this.childItem.hatchuNo,
      };

      const res = await this.$store.dispatch('g040/getRireki', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        this.messageShow = true;
        return;
      }

      this.items = res.data.responseData ? res.data.responseData : [];
    },
  },
  created() {
    this.getRireki();
  },
});
